import { render } from "./AnnuaireCard.vue?vue&type=template&id=1472da70"
import script from "./AnnuaireCard.vue?vue&type=script&lang=js"
export * from "./AnnuaireCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__